<template>
  <div class="row delivery-container">
    <div class="col-md-12 mb20 delivery-title">
      <Replacing v-if="showReplacing" :unavailableParcelshop="finalDestination" />
      <AllowedReturn v-if="showAllowedReturn" />
    </div>

    <template v-if="hasGroups">
      <div class="grey-line"></div>

      <h3 class="summary-title">
        {{ $t('tracking.delivery.summaryLabel') }}
      </h3>
    </template>

    <div class="col-md-12 pr0 pl0 summary-container summary--column" v-if="!isReplacingViewActive">
      <StepCard
        v-for="(stepDay, index) in groups"
        :key="stepDayKey(stepDay, index)"
        :stepDay="stepDay"
        :isFirstCard="index === 0"
        :partnerInfos="index === 0 ? latestPartnerInfos : null"
      />
    </div>
  </div>
</template>

<script>
import StepCard from '../StepCard/StepCard';
import Replacing from '../Replacing/Replacing';
import AllowedReturn from '../AllowedReturn/AllowedReturn';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    AllowedReturn,
    Replacing,
    StepCard,
  },
  computed: {
    ...mapState([
      'deliveryCheckpoints',
      'allowedOperations',
      'finalDestination',
      'allowedReturn',
      'isReplacingViewActive',
    ]),
    ...mapGetters(['getCheckpointsGroupedByDates']),
    groups() {
      return this.getCheckpointsGroupedByDates || [];
    },
    latestPartnerInfos() {
      for (const stepDay of this.groups) {
        const steps = Array.isArray(stepDay) ? [...stepDay].reverse() : [];
        const partnerStep = steps.find(step => {
          const url = step?.InformationsPartenaire?.UrlSuiviColisPartenaire;
          return typeof url === 'string' && url.trim().length > 0;
        });

        if (partnerStep) {
          return {
            ...partnerStep.InformationsPartenaire,
            UrlSuiviColisPartenaire:
              partnerStep.InformationsPartenaire.UrlSuiviColisPartenaire.trim(),
          };
        }
      }

      return null;
    },
    hasGroups() {
      return this.groups.length > 0;
    },
    showReplacing() {
      return Array.isArray(this.allowedOperations) && this.allowedOperations.length > 0;
    },
    showAllowedReturn() {
      return !!this.allowedReturn;
    },
  },
  methods: {
    stepDayKey(stepDay, fallbackIndex) {
      const first = stepDay && stepDay[0];
      const dt = first && first.Date;
      return dt ? `day-${dt.slice(0, 10)}` : `idx-${fallbackIndex}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import './DeliverySummary.scss';
</style>
